export default __webpack_public_path__ + "static/tab-property01-4bc2d13a99efb6d177debcecda852da4.jpg";